module.exports = __webpack_public_path__ + "static/media/art3.68526b48.png";